import { Ed25519, Ed25519Pk } from "./Ed25519.js";
import { Willow25 } from "./Willow25.js";
export class NamespaceId extends Ed25519Pk {
    static default() {
        return this.copy(Willow25.DEFAULT_NAMESPACE_ID);
    }
    static isCommunal(namespaceId) {
        return (namespaceId[NamespaceId.LENGTH - 1] & 0b0000_0001) === 0;
    }
    static isOwned(namespaceId) {
        return !this.isCommunal(namespaceId);
    }
    static async generateRandomCommunalNamespaceKeys() {
        let keys;
        do {
            keys = await Ed25519.generateKey();
        } while (!NamespaceId.isCommunal(keys.publicKey));
        return keys;
    }
    static async generateRandomOwnedNamespaceKeys() {
        let keys;
        do {
            keys = await Ed25519.generateKey();
        } while (!NamespaceId.isOwned(keys.publicKey));
        return keys;
    }
}
//# sourceMappingURL=NamespaceId.js.map